import { useState } from "react";
import { Button, Container, Form } from "react-bootstrap";
import emailjs from 'emailjs-com';
import './ContactUs.css'

export default function ContactUsPage() {
    const [name, setName] = useState('')
    const [contact, setContact] = useState('')
    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(false)

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        setLoading(true)
        const templateParams = {
            user_email: process.env.REACT_APP_EMAIL_CONFIG_EMAIL,
            to_name: 'Faii',
            from_name: name,
            reply: contact,
            message: content,
        }

        try {
            await emailjs.send(
                process.env.REACT_APP_EMAIL_CONFIG_SERVICE + '',
                process.env.REACT_APP_EMAIL_CONFIG_TEMPLATE + '',
                templateParams,
                process.env.REACT_APP_EMAIL_CONFIG_TOKEN,
            )
            setContact('')
            setContent('')
            setName('')
            setLoading(false)
        } catch (e) {
            console.log(e)
        }
    }

    return (
        <Container className="contact-us-container">
            <h2 className="text-center mt-4">聯絡我們</h2>
            <Form onSubmit={handleSubmit} className="contact-form">
                <Form.Group controlId="name">
                    <Form.Label>你的名字</Form.Label>
                    <Form.Control
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                    />
                </Form.Group>

                <Form.Group controlId="contact">
                    <Form.Label>你的電話或回覆電郵</Form.Label>
                    <Form.Control
                        type="text"
                        value={contact}
                        onChange={(e) => setContact(e.target.value)}
                        required
                    />
                </Form.Group>

                <Form.Group controlId="content">
                    <Form.Label>內容</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        value={content}
                        onChange={(e) => setContent(e.target.value)}
                        required
                    />
                </Form.Group>

                <Button variant="primary" type="submit" className="mt-3 w-100" disabled={loading}>
                    提交
                </Button>
            </Form>
        </Container>
    )
}
